import React, { useEffect, useState } from "react";
import { X } from "react-feather";

// internal rebet imports
import "./stylesGamePassTogglePopup.css";

// component imports
import RebetLoader from "../../../../../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../../api/ApiRoutes";

import { message, Popconfirm } from "antd";
import ToggleSwitch from "../../../../../CommonComponents/ToggleSwitch/ToggleSwitch";
import { fetchSpecificUsersData } from "../../../../../../api/CommonFunctions/CommonFunctions";

const GamePassTogglePopup = ({
  isVisible,
  onClosePressed,
  userId,
  userData,
}) => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    false
  );
  // state variables
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [gamePassOption, setGamePassOption] = useState([]);
  const [gamePassPremiumOption, setGamePassPremiumOption] = useState([]);

  const handleToggleGamePassChange = async (updatedFlag) => {
    const updatedOption = !updatedFlag.status;

    const payload = {
      user_id: userData.user_id,
      game_pass_enabled: updatedOption,
    };

    try {
      const res = await PrivateAdminPanelInstance.post(
        API_ROUTES.UPDATE_USER_GAME_PASS_STATUS,
        payload
      );

      setGamePassOption((prevOptions) =>
        prevOptions.map((option, index) => {
          if (index === prevOptions.length - 1) {
            return { ...option, status: updatedOption };
          }
          return option;
        })
      );

      messageApi.success(res.data.message);
    } catch (error) {
      messageApi.error("Failed to update feature flag.");
      console.error("Update error:", error);
    }
  };

  const handleToggleGamePassPremiumChange = async (updatedFlag) => {
    const updatedOption = !updatedFlag.status;

    const payload = {
      user_id: userData.user_id,
      game_pass_premium_enabled: updatedOption,
    };

    try {
      const res = await PrivateAdminPanelInstance.post(
        API_ROUTES.UPDATE_USER_GAME_PASS_PREMIUM_STATUS,
        payload
      );

      setGamePassPremiumOption((prevOptions) =>
        prevOptions.map((option, index) => {
          if (index === prevOptions.length - 1) {
            return { ...option, status: updatedOption };
          }
          return option;
        })
      );

      messageApi.success(res.data.message);
    } catch (error) {
      messageApi.error("Failed to update feature flag.");
      console.error("Update error:", error);
    }
  };

  const getNewestUserData = async () => {
    if (!userId) return;

    const newestUserData = await fetchSpecificUsersData(
      PrivateAdminPanelInstance,
      userId
    );
    console.log("newestUserData", newestUserData);
    setGamePassOption([
      {
        id: 1,
        name: `Is Game Pass Enabled for ${newestUserData.username}?`,
        status: newestUserData.game_pass_enabled ?? false,
      },

    ]);
    setGamePassPremiumOption([
      {
        id: 2,
        name: `Is Game Pass Premium Enabled for ${newestUserData.username}?`,
        status: newestUserData.game_pass_premium_enabled ?? false,
      },
    ]);
  };

  const handleClosePressed = () => {
    onClosePressed();
  };

  useEffect(() => {
    getNewestUserData();
  }, [userData]);

  if (!isVisible) return null;

  return (
    <div className="suspend-user-popup user-game-pass-popup">
      {contextHolder}
      <div className="suspend-user-panel">
        {isApiRunning ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="suspend-user-header">
              <div className="suspend-user-header-label">
                Game Pass Toggle
              </div>
              <button className="close-button" onClick={handleClosePressed}>
                <X className="close-icon" />
              </button>
            </div>
            <div className="user-game-pass-container">
              {gamePassOption.map((option) => (
                <div key={option.id} className="feature-flag-item">
                  <div className="feature-flag-label">{option.name}</div>
                  <div className="user-game-pass-toggle-container">
                    <span className={`user-game-pass-toggle-status ${option.status ? "enabled" : "disabled"}`}>
                      {option.status ? "Yes" : "No"}
                    </span>
                    <ToggleSwitch
                      status={option.status}
                      eventCode={option.id}
                      updateEventCode={handleToggleGamePassChange}
                      data={option}
                      onlyUpdate={true}
                    />
                  </div>
                </div>
              ))}
              {gamePassPremiumOption.map((option) => (
                <div key={option.id} className="feature-flag-item">
                  <div className="feature-flag-label">{option.name}</div>
                  <div className="user-game-pass-toggle-container">
                    <span className={`user-game-pass-toggle-status ${option.status ? "enabled" : "disabled"}`}>
                      {option.status ? "Yes" : "No"}
                    </span>
                    <ToggleSwitch
                      status={option.status}
                      eventCode={option.id}
                      updateEventCode={handleToggleGamePassPremiumChange}
                      data={option}
                      onlyUpdate={true}
                    />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GamePassTogglePopup;
